// extracted by mini-css-extract-plugin
export default {"mainContainer":"Nruzmlr7vB66+KGKdebHig==","content":"rAiE-Wx5zeyF8eRY6wIcYQ==","illustration":"_0Fdjb3gBlzi-QD+HoZdCEg=="};